// src/views/litellm/components/TopStatsTable.jsx
import React from "react";
import { usd, compactNumber } from "../format";

// TopStatsTable renders a top-N breakdown (name + events/cost/tokens). Clicking a row
// calls onSelect with the row's raw filter value (source_key or model) to drive drill-down.
export default function TopStatsTable({
  title,
  nameHeader,
  rows = [],
  getName,
  getFilterValue,
  selectedValue,
  onSelect,
}) {
  return (
    <div className="bg-card rounded-card border border-card-bd p-5">
      <div className="text-xs font-semibold uppercase tracking-wide text-text-3 mb-3">{title}</div>
      {rows.length === 0 ? (
        <div className="text-sm text-text-3 py-4">No data.</div>
      ) : (
        <table className="text-sm" style={{ width: "100%" }}>
          <thead>
            <tr className="text-text-3 text-xs uppercase tracking-wide">
              <th className="text-left font-semibold pb-2">{nameHeader}</th>
              <th className="text-right font-semibold pb-2">Events</th>
              <th className="text-right font-semibold pb-2">Cost</th>
              <th className="text-right font-semibold pb-2">Tokens</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const value = getFilterValue(r);
              const selected = selectedValue != null && value === selectedValue;
              return (
                <tr
                  key={value}
                  onClick={() => onSelect && onSelect(value)}
                  className={`cursor-pointer border-t border-card-bd hover:bg-surface-2 ${
                    selected ? "bg-surface-2" : ""
                  }`}
                >
                  <td className="py-2 text-left text-text font-medium truncate max-w-[180px]">{getName(r)}</td>
                  <td className="py-2 text-right tabular-nums text-text-2">{compactNumber(r.events)}</td>
                  <td className="py-2 text-right tabular-nums text-text-2">{usd(r.cost)}</td>
                  <td className="py-2 text-right tabular-nums text-text-2">{compactNumber(r.tokens)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
